import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {ApplicationService} from '../application.service';
import {Constant} from '../../../global/util/Constant';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private applicationService: ApplicationService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
      const isSuperadmin = this.authService.hasRole(Constant.ROLE_SUPERADMIN);
      const needsEnterprises = isSuperadmin || this.authService.hasRole(Constant.ROLE_PARTNER);
      const hasWorkflows = this.hasStoredArray('workflows');
      const hasEnterprises = !needsEnterprises || this.hasStoredArray('enterprises');
      const hasPartners = !isSuperadmin || this.hasStoredArray('partners');
      if (LocalStorage.isInvitedAuthenticated() || (hasWorkflows && hasEnterprises && hasPartners)) {
        return true;
      }
      return this.applicationService.get(Constant.ROOT_API_V1 + '/staticdata').pipe(
        map((response: any) => {
          if (!response || !response._embedded || !Array.isArray(response._embedded.workflows) ||
              (needsEnterprises && !Array.isArray(response._embedded.enterprises)) ||
              (isSuperadmin && !Array.isArray(response._embedded.partners))) {
            throw new Error('La respuesta de /staticdata no contiene los datos requeridos para este perfil');
          }
          LocalStorage.setUpEmbeddedInfo(response);
          return true;
        }),
        catchError(error => {
          console.error('No se pudieron cargar los datos iniciales', error);
          this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
          return of(false);
        })
      );
    }
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }

  private hasStoredArray(key: string): boolean {
    try {
      return Array.isArray(JSON.parse(localStorage.getItem(key) || 'null'));
    } catch (_) {
      return false;
    }
  }
}
